import { useRef, useState } from "react"
import PropTypes from "prop-types"
import { PlusSvg, MinusSvg } from "@/components/svgs"

const SearchAccordion = ({ children, header }) => {
  const ref = useRef()
  const [open, setOpen] = useState(false)

  return (
    <div
      className="w-full  bg-gray-100 float-right lg:w-[calc(100%-210px)] md:w-[calc(100%-210px)] border-b border-[#bebebe]
      last:border-b-0"
    >
      <details ref={ref}>
        <summary className="list-none">
          <span
            className="flex justify-between relative p-[20px] text-[14px] leading-1 uppercase text-gray-800 hover:cursor-pointer"
            onClick={() => setOpen(!ref.current.open)}
          >
            {header}
            {!open ? <PlusSvg /> : <MinusSvg />}
          </span>
        </summary>
        {open ? children : null}
      </details>
    </div>
  )
}

SearchAccordion.propTypes = {
  children: PropTypes.node,
  header: PropTypes.string,
}

export default SearchAccordion
